const camelize = str => str.replace(/_([a-z])/g, (_, letter) => letter.toUpperCase())
  
export const camelizeKeys = obj => {
if (Array.isArray(obj)) {
    return obj.map(camelizeKeys)
} else if (obj !== null && typeof obj === 'object') {
    return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => [camelize(key), camelizeKeys(value)])
    )
}
return obj
}
  